module.exports = __webpack_public_path__ + "static/ConcishareQr-efb4f52147ae07c5a01222e057809875.png";